import { generatePath } from 'react-router'

/**
 * The route pattern the reconnect match step mounts at, with `:itemId` the NEW
 * item (the one `GET /aggregator/items/{id}/relink` answers for). Exported so
 * the screen's real route and every test mount it from this one literal and
 * cannot spell it two ways. Declared as a plain `const` string literal so
 * `App.test.tsx`'s `path={CONSTANT}` resolver can read it.
 */
export const RELINK_MATCH_ROUTE = '/connections/reconnect/:itemId'

/**
 * Where a reconnect's match step lives, built from `RELINK_MATCH_ROUTE` so the
 * builder and the route are the same string by construction. One builder so the
 * Plaid OAuth return and the screens never spell the path twice.
 */
export function relinkMatchPath(newItemId: string): string {
  return generatePath(RELINK_MATCH_ROUTE, { itemId: newItemId })
}
